import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
const cn = (...inputs) => twMerge(clsx(inputs));

const NoDataFound = ({ className, title, description, searchValue }) => {
  return (
    <div
      className={cn(
        "w-full relative flex flex-col gap-4 items-center justify-center h-[calc(100dvh-100px)]",
        className
      )}
    >
      <div>
        <h1 className="text-xl font-bold text-center text-gray-900 dark:text-gray-100">{title}</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
          {`${description} "${searchValue}".`}
        </p>
      </div>
    </div>
  );
};

export default NoDataFound;
